import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../../../commonComponents/forms/FormInput';
import translate from '../../../../../commonComponents/translate';
import { isFieldRequiredLabel } from '../../../helpers/helper';
import RequiredFieldsPerBlockProp from '../../../../../commonComponents/propTypes/requiredFieldsPerBlockProp';
import UserProp from '../../../../../commonComponents/propTypes/userProp';

function ProfileField({
  t,
  field,
  type,
  value,
  hint,
  onChange,
  inputProps,
  labelClassName,
  containerClassName,
  groupClassName,
  disabled,
  placeholder,
  block,
  requiredFieldsPerBlock,
  inputField,
  nameField,
  user,
  labelKey,
}) {
  const label = useMemo(() => {
    // Optional override for the base label key (e.g. country-aware bank fields — BRAVON-6285).
    const baseLabel = labelKey ? t(labelKey) : t(`profile_${field}`);
    if (field === 'email') {
      return `${baseLabel}*`;
    }
    return isFieldRequiredLabel(
      requiredFieldsPerBlock,
      block,
      inputField || field,
      baseLabel,
      undefined,
      field === 'SIREN' || field === 'NIF' ? user : undefined,
      (field === 'SIREN' || field === 'NIF') && inputProps
        ? inputProps('businessType')?.items
        : [],
    );
  }, [block, requiredFieldsPerBlock, inputField, user, inputProps, labelKey]);
  return (
    <FormInput
      id={field}
      name={nameField || field}
      value={value}
      onChange={change => onChange(field, change)}
      label={label}
      labelClassName={labelClassName}
      containerClassName={containerClassName}
      placeholder={placeholder || t(`profile_${field}Placeholder`)}
      type={type}
      hint={hint}
      groupProps={{ className: `row ${groupClassName}` }}
      inputProps={inputProps ? inputProps(field) : {}}
      disabled={disabled}
    />
  );
}

ProfileField.propTypes = {
  t: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
    PropTypes.bool,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
  inputProps: PropTypes.func,
  type: PropTypes.string,
  hint: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  block: PropTypes.string,
  inputField: PropTypes.string,
  nameField: PropTypes.string,
  requiredFieldsPerBlock: PropTypes.shape(RequiredFieldsPerBlockProp.propType),
  user: PropTypes.shape(UserProp.propType),
  labelKey: PropTypes.string,
};

ProfileField.defaultProps = {
  type: 'text',
  value: undefined,
  hint: undefined,
  labelClassName: 'col-lg-2 col-sm-12',
  containerClassName: 'col-lg-7 col-sm-12',
  groupClassName: '',
  disabled: false,
  inputProps: null,
  placeholder: null,
  block: '',
  inputField: null,
  nameField: null,
  requiredFieldsPerBlock: RequiredFieldsPerBlockProp.defaultProp,
  user: {},
  labelKey: null,
};

export default React.memo(translate(ProfileField));
